export default "__VITE_ASSET__BjwUNdjh__"